var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOdnoklassniki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40ZM22.1642 24.8231C23.2537 24.5962 24.3028 24.2017 25.2683 23.6468C25.9991 23.2251 26.2203 22.3423 25.7591 21.6715C25.2979 21.0007 24.3325 20.7985 23.5989 21.2202C21.4091 22.4803 18.5909 22.4779 16.4011 21.2202C15.6676 20.7985 14.7021 21.0007 14.2409 21.6715C13.7797 22.3398 14.0009 23.2251 14.7317 23.6468C15.6972 24.2017 16.7463 24.5962 17.8358 24.8231L14.8504 27.5555C14.2382 28.1153 14.2382 29.0203 14.8504 29.5802C15.1578 29.8588 15.557 29.9994 15.9561 29.9994C16.3579 29.9994 16.757 29.8588 17.0645 29.5802L20.0013 26.8946L22.9382 29.5802C23.5504 30.14 24.5401 30.14 25.1523 29.5802C25.7645 29.0204 25.7645 28.1128 25.1523 27.5555L22.1642 24.8231ZM20 20C22.7573 20 25 17.7573 25 15.0025C25 12.2427 22.7573 10 20 10C17.2427 10 15 12.2427 15 15C15 17.7573 17.2427 20 20 20ZM20 12.9314C21.1428 12.9314 22.0712 13.8597 22.0712 15.0025C22.0712 16.1428 21.1428 17.0711 20 17.0711C18.8597 17.0711 17.9288 16.1428 17.9288 15.0025C17.9288 13.8597 18.8597 12.9314 20 12.9314Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassniki);
export default ForwardRef;